exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-5c6dbfba]{top:0;background:#fff;z-index:2}.footer-absolute[data-v-5c6dbfba],.header[data-v-5c6dbfba]{position:fixed;right:0;left:0;overflow:hidden}.footer-absolute[data-v-5c6dbfba]{bottom:0;color:#74788d;background-color:#f2f2f5}.content[data-v-5c6dbfba]{margin-top:68px;margin-bottom:68px;overflow:auto}.ui-button[data-v-5c6dbfba]{float:left;width:50%;font-size:1.9rem;padding:8px;cursor:pointer;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.row[data-v-5c6dbfba]{margin-left:0;margin-right:0}.text-yellow[data-v-5c6dbfba]{color:#ff0}", ""]);

// exports
